import React, { useContext, useEffect } from "react";
import { Navbar, Nav } from "react-bootstrap";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { Button, Icon, Radio } from "semantic-ui-react";
import { ThemeContext } from "../../ThemedContext/Provider";
import { useSelector, useDispatch } from "react-redux";
import { clearUser, loadUser } from "../../redux/user-redux/userStore";

const Navs = () => {
  const { theme, setTheme } = useContext(ThemeContext);
  // const [token, setToken] = useState(sessionStorage.getItem("auth_session"));
  const history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector(({ useReducer: { user } }) => user);
  const localStore = JSON.parse(sessionStorage.getItem("auth_user"));
  useEffect(() => {
    if (localStore) {
      loadUser(dispatch);
    }
  }, [dispatch, localStore]);
  return (
    <Wrapper expand='lg' themed={`${theme}`} sticky='top'>

      <BrandStyle themed={theme}>
        <Nav.Link href='/' className='links'>Snitch</Nav.Link>
      </BrandStyle>

      <Navbar.Toggle aria-controls='basic-navbar-nav'>
        <Icon name='bars' style={{ color: theme ? "#fff" : "#1e1e1e" }} />
      </Navbar.Toggle>

      <Navbar.Collapse id='basic-navbar-nav'>
        <NavStyle style={{ width: '45%' }}>
          <Nav.Link href='/songs' className='links'>Songs</Nav.Link>
          <Nav.Link href='/artists' className='links'>Artists</Nav.Link>
          <Nav.Link href='/featured' className='links'>Featured</Nav.Link>
          <Nav.Link href='/news' className='links'>News</Nav.Link>
        </NavStyle>

        <Nav className='d-flex justify-content-end' style={{ width: '100%' }}>
          <SearchInputHolder>
            <Input
              themed={theme}
              type='search'
              className='mr-5 input'
              size='small'
              icon={{ name: 'search', circular: true, link: true }}
              placeholder='Search...'
            />
            <Icon name='search' className='searchIcon' />
          </SearchInputHolder>

          <SectionThree>
            {sessionStorage.getItem("auth_user") ? (
              <>
                <Button
                  animated='true'
                  color='red'
                  onClick={() => {
                    sessionStorage.removeItem("auth_user");
                    sessionStorage.removeItem("auth_session");
                    clearUser(dispatch);
                    history.push("/login");
                  }}
                >
                  <Button.Content visible>Logout</Button.Content>
                  <Button.Content hidden>
                    <Icon name='user' />
                  </Button.Content>
                </Button>
                <Logo>
                  <Nav.Link className='links' href='/artist'>
                    {user.profile_pic ? (
                      <Image>
                        <img src={user.profile_pic} alt='Profile' />
                      </Image>
                    ) : (
                      <Round>
                        {user && user.first_name.slice(0, 2).toUpperCase()}
                      </Round>
                    )}
                  </Nav.Link>
                </Logo>
              </>
            ) : (
              <>
                <Nav.Link
                  style={{ color: '#f94e3f' }}
                  animated='true'
                  onClick={() => {
                    history.push("/login");
                  }}
                >
                  Login
                </Nav.Link>
              </>
            )}

            <ThemeToggleHolder>
              <Radio checked={theme} toggle onChange={() => setTheme(!theme)} />
            </ThemeToggleHolder>

          </SectionThree>
        </Nav>
      </Navbar.Collapse>
    </Wrapper >
  );
};

export default Navs;

const ThemeToggleHolder = styled.div`
  position: fixed;
  top: 43vh;
  right: 2.5vw;

  @media (min-width: 280px ) and ( max-width: 991px) {
    top: 40vh;
    right: 1vw;
  }
`;

const NavStyle = styled(Nav)`
  display: flex;
  justify-content: space-between;
  width: 30%;
  margin-left: 5em;

  @media (min-width: 200px ) and ( max-width: 991px) {
    margin-left: 0;
    margin-bottom: 1em;

    .links {
      margin: 0
      padding: 1em 0;
      margin-top: 0.5em;
    }
  }

  .links {
    width: 6em;
    color: #f94e3f !important;
  }
`;

const BrandStyle = styled.div`
  .links {
    color: ${({ themed }) => (themed ? "#fff" : "#04031D")} !important;
    font-size: 1.5em;
    text-decoration: none;
  }
`;

const Wrapper = styled(Navbar)`
  padding-left: 5%;
  padding-right: 5%;
  background: ${({ themed }) => (themed === 'true' ? "#0f0e37" : "#ffffff")} !important;
  color: ${({ themed }) => (themed === 'true' ? "#ffffff" : "#04031D")} !important;

    Icon {
      color: ${({ themed }) => (themed === 'true' ? "#0f0e37" : "#ffffff")} !important;
      border-color: ${({ themed }) => (themed === 'true' ? "#0f0e37" : "#ffffff")} !important;
  }
`;

const SearchInputHolder = styled.div`
  position: relative;
  max-width: 20em;
  width: 100%;
  margin-right: 1rem;

  .searchIcon{
    position: absolute;
    top: 0.5em;
    right: 1px;
    color: rgb(255 69 0 / 18%);
  }
`;

export const Input = styled.input`
    width: 100%;
    padding: 0.5em 0em;
    outline: none;
    border: transparent;
    box-shadow: 0 1px 0px rgb(255 255 255 / 10%);
    background: transparent !important;
    display: inline-block;
    color: ${({ themed }) => themed ? '#fff' : 'inherit'};

  &:focus {
    transition: all 0.5s ease-in-out;
    background-color: transparent;
    box-shadow: 0 1px 0px rgb(255 69 0);
  }

  &:focus + .searchIcon{
    color: rgb(255 69 0);
  }

  &::placeholder{
    color: grapy
  }
`;

const SectionThree = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  img {
    margin-right: 15px;
  }

  @media (min-width: 280px ) and ( max-width: 991px) {
   .ui.orange.button{
     margin-top: 2em;
     margin-bottom: 2em;
   }
`;

export const Image = styled.div`
  img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
`;

export const Logo = styled.div`
  width: 40px;
  height: 40px;
  margin-left: 0.5em;
  margin-right: 0.5em;

  .links{
    color: white !important;
  }
  .nav-link{
    padding: 0;
    margin: 0;
  }
`;

export const Round = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1em;
  background: #f94e3f;
  color: white;
  cursor: pointer;
`;
